import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/kpi/deduction";

export default {
    /** 分页查询扣分记录 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 登记扣分 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除扣分 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
};
